/* Paths */
import { claimPaths } from "common/data/routePaths"
import { lazy } from "react"

/*
Components
*/

const ClaimPrint = lazy(() => import("pages/Claims/ClaimForm/Print/ClaimPrint"))
const SearchResults = lazy(() => import("pages/Claims/ClaimForm/SearchResults"))

// Add Claim
const ClaimForm = lazy(() => import("pages/Claims/ClaimForm"))
// Add Claim
const AddClaimForm = lazy(() => import("pages/Claims/ClaimForm/Tabs"))

const { claimForm: claimFormPath } = claimPaths
export const ClaimRoutes = [
  // Claim Form
  { path: claimFormPath, component: ClaimForm },

  // search results Claim
  { path: `${claimFormPath}/search-results`, component: SearchResults },
  // print Claim
  {
    path: `${claimFormPath}/print/:claimId`,
    component: ClaimPrint,
  },
  // view Claim
  {
    path: `${claimFormPath}/view/:claimId`,
    component: AddClaimForm,
  },
]
